import { DeepMap, FieldError, FieldValues, Path, UseFormRegister } from 'react-hook-form'

type TFormTextAreaProps<TFormValues extends FieldValues> = {
  register: UseFormRegister<TFormValues>
  errors?: Partial<DeepMap<TFormValues, FieldError>>
  nombreCampo: Path<TFormValues>
  nombre?: string
  defaultValue?: string
  isObligatorio?: boolean
  placeholder?: string
}

/**
 * Wrapper generico de textarea con react-hook-form.
 * Renderiza label + textarea + mensaje de error.
 */
const FormTextArea = <TFormValues extends Record<string, unknown>>({
  nombre,
  register,
  errors,
  nombreCampo,
  defaultValue,
  isObligatorio,
  placeholder,
  ...props
}: TFormTextAreaProps<TFormValues> & React.TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return (
    <>
      {nombre && (
        <label className='form-label fs-3'>
          {nombre} {isObligatorio && <span className='text-danger'>*</span>}
        </label>
      )}
      <textarea
        {...register(nombreCampo)}
        required={isObligatorio}
        className='form-control form-control-solid'
        placeholder={placeholder}
        defaultValue={defaultValue}
        {...props}></textarea>
      {errors && errors[nombreCampo] && (
        <p className='pt-2 text-danger text-end fs-5'>{errors && errors[nombreCampo]?.message}</p>
      )}
    </>
  )
}

export default FormTextArea
